import { inject, Injectable } from '@angular/core';
import { JobDetailsStore } from 'src/app/recruiting/locums-margin-calculator/store/job-details/job-details.store';
import { MarginSetupStore } from 'src/app/recruiting/locums-margin-calculator/store/margin-setup/margin-setup.store';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { JobService } from 'src/app/recruiting/locums-margin-calculator/services/job.service';
import { JobInfo } from 'src/app/recruiting/locums-margin-calculator/models/job-info.models';
import { initialJobDetailsSlice } from 'src/app/recruiting/locums-margin-calculator/store/job-details/job-details.slice';
import { initialMarginSetupSlice } from 'src/app/recruiting/locums-margin-calculator/store/margin-setup/margin-setup.slice';

@Injectable({ providedIn: 'root' })
export class JobEffects {
    private readonly jobDetailsStore = inject(JobDetailsStore);
    private readonly marginSetupStore = inject(MarginSetupStore);
    private readonly jobService = inject(JobService);

    readonly loadJobDetails = rxMethod<number>((query$) =>
        query$.pipe(
            switchMap((jobId: number) =>
                this.jobService.getJobInfo(jobId).pipe(
                    tapResponse({
                        next: (jobInfo: JobInfo) => {
                            this.updateStores(jobInfo);
                        },
                        error: () => {
                            this.jobDetailsStore.updateJobDetailsFromData({ ...initialJobDetailsSlice });
                            this.marginSetupStore.updateMarginSetupFromData({ ...initialMarginSetupSlice });
                        }
                    })
                )
            )
        )
    );

    private updateStores(jobInfo: JobInfo) {
        this.jobDetailsStore.updateJobDetailsFromData({
            jobTitle: jobInfo.jobTitle,
            jobId: jobInfo.jobId,
            employmentType: jobInfo.employmentType,
            facilityId: jobInfo.facilityId,
            facilityName: jobInfo.facilityName,
            facilityLocation: jobInfo.facilityLocation,
            profession: jobInfo.profession,
            specialty: jobInfo.specialty,
            unitId: jobInfo.unitId,
            unitFormId: jobInfo.unitFormId,
            unitDescription: jobInfo.unitDescription,
            accountManager: jobInfo.accountManager,
            accountCoordinator: jobInfo.accountCoordinator
        });

        // it will be handled after we have the rules for the margin setup
        //
        // this.marginSetupStore.updateMarginSetupFromData({
        //     contractStartDate: jobInfo.contractStartDate,
        //     contractEndDate: jobInfo.contractEndDate,
        //     days: jobInfo.days,
        //     hoursPerShift: jobInfo.hoursPerShift,
        //     totalHours: jobInfo.totalHours,
        //     billRate: jobInfo.billRate,
        //     payRate: jobInfo.payRate,
        //     overtimeBillRate: jobInfo.overtimeBillRate,
        //     overtimePayRate: jobInfo.overtimePayRate,
        //     overtimeRateFactor: jobInfo.overtimeRateFactor,
        //     holidayBillRate: jobInfo.holidayBillRate,
        //     holidayPayRate: jobInfo.holidayPayRate,
        //     holidayRateFactor: jobInfo.holidayRateFactor
        // });
    }
}
